// import React, { useEffect, useRef, useState } from "react";
// import {
//   ChevronLeft,
//   ChevronRight,
//   Heart,
//   Loader2,
//   Star,
//   FilterX,
// } from "lucide-react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import toast from "react-hot-toast";
// import { useCart } from "../../utils/CartContext";
// import { useCurrency } from "../../context/CurrencyContext";
// import { formatingPrice } from "../../utils/formatingPrice";
// import { useTranslation } from "react-i18next";

// const ProductSection = ({
//   title = "Shop By Category",
//   filters = ["New Products", "Best Sellers", "Featured"],
//   banner = {
//     title: "Milancelos",
//     subtitle: "Huge Saving on Home Appliances",
//     discount: "",
//     image: "/api/placeholder/250/250",
//   },
//   products = [],
//   categoryId,
// }) => {
//   const scrollRef = useRef(null);
//   const { currency, convertPrice } = useCurrency();
//   const { t, i18n } = useTranslation();
//   const currentLanguage = i18n.language || "en";

//   const [activeFilter, setActiveFilter] = useState(filters[0]);
//   const [wishlist, setWishlist] = useState([]);
//   const [loadingHearts, setLoadingHearts] = useState(new Set());
//   const [loadingCart, setLoadingCart] = useState(new Set());
//   const navigate = useNavigate();
//   const { fetchCartCount } = useCart();

//   // Helper function to get localized text
//   const getLocalizedText = (item, field) => {
//     if (!item || !item[field]) return "";
    
//     // If value is a string (backward compatibility)
//     if (typeof item[field] === 'string') {
//       return item[field];
//     }
    
//     // If value is an object with language keys
//     if (typeof item[field] === 'object') {
//       // Return the value in current language, fallback to English, then first available
//       return item[field][currentLanguage] || 
//              item[field].en || 
//              item[field].hi || 
//              item[field].es || 
//              item[field].zh || 
//              "";
//     }
    
//     return "";
//   };

//   // Get logged user
//   const storedUser = localStorage.getItem("pm-user-data");
//   const user = storedUser ? JSON.parse(storedUser) : null;
//   const userId = user?._id;

//   useEffect(() => {
//     AOS.init({ duration: 800, easing: "ease-out", once: true });
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   // Load wishlist
//   const fetchWishlist = async () => {
//     if (!userId) {
//       const localWishlist = JSON.parse(
//         localStorage.getItem("guestWishlist") || "[]"
//       );
//       setWishlist(localWishlist);
//       return;
//     }
//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/wishlist/wishlist-by-user/${userId}`
//       );
//       const ids = res?.data?.products?.map((p) => p._id?.toString()) || [];
//       setWishlist(ids);
//     } catch (error) {
//       console.error("❌ Error fetching wishlist:", error);
//     }
//   };

//   useEffect(() => {
//     fetchWishlist();
//   }, [userId]);

//   // Wishlist toggle
//   const toggleWishlist = async (productId) => {
//     if (!userId) {
//       toast.error(t("login_for_wishlist"));
//       return;
//     }

//     const isLiked = wishlist.includes(productId.toString());
//     setLoadingHearts((prev) => new Set(prev).add(productId));

//     try {
//       const endpoint = isLiked
//         ? `${process.env.REACT_APP_API_URL}/wishlist/remove-from-wishlist`
//         : `${process.env.REACT_APP_API_URL}/wishlist/add-to-wishlist`;

//       await axios.post(endpoint, { userId, productId });
//       await fetchWishlist();
//     } catch (error) {
//       toast.error(t("something_went_wrong"));
//     } finally {
//       setLoadingHearts((prev) => {
//         const newSet = new Set(prev);
//         newSet.delete(productId);
//         return newSet;
//       });
//     }
//   };

//   // Scroll function
//   const scroll = (direction) => {
//     if (!scrollRef.current) return;
//     const scrollAmount = 320;
//     scrollRef.current.scrollBy({
//       left: direction === "left" ? -scrollAmount : scrollAmount,
//       behavior: "smooth",
//     });
//   };

//   // Add to cart
//   const handleAddToCart = async (productId) => {
//     if (!userId) {
//       toast.error(t("login_for_cart"));
//       return;
//     }

//     setLoadingCart((prev) => new Set(prev).add(productId));
//     try {
//       await axios.post(
//         `${process.env.REACT_APP_API_URL}/cart/add-product-to-cart`,
//         {
//           userId,
//           productId,
//           quantity: 1,
//         }
//       );
//       toast.success(t("added_to_cart"));
//       fetchCartCount();
//     } catch (error) {
//       toast.error(t("add_to_cart_failed"));
//     } finally {
//       setLoadingCart((prev) => {
//         const newSet = new Set(prev);
//         newSet.delete(productId);
//         return newSet;
//       });
//     }
//   };

//   const handleProductClick = (id) => navigate(`/product-details/${id}`);

//   // IMPROVED FILTER LOGIC WITH BETTER ERROR HANDLING
//   let filteredProducts = [...products];

//   // NEW PRODUCTS → Show products from last 30 days
//   if (activeFilter === "New Products") {
//     const thirtyDaysAgo = new Date();
//     thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

//     filteredProducts = products.filter((product) => {
//       if (!product.createdAt) return false;
//       const productDate = new Date(product.createdAt);
//       return productDate >= thirtyDaysAgo;
//     });

//     // If no recent products, show all products sorted by newest first
//     if (filteredProducts.length === 0) {
//       filteredProducts = [...products]
//         .sort((a, b) => {
//           const dateA = a.createdAt ? new Date(a.createdAt) : new Date(0);
//           const dateB = b.createdAt ? new Date(b.createdAt) : new Date(0);
//           return dateB - dateA;
//         })
//         .slice(0, 8);
//     }
//   }

//   // BEST SELLERS → Products with highest ratings (4+ stars) and good sales data
//   if (activeFilter === "Best Sellers") {
//     filteredProducts = products.filter((product) => {
//       const rating = typeof product.ratings === "number" ? product.ratings : 0;
//       const hasHighRating = rating >= 4.0;
//       const hasGoodSalesIndicator =
//         product.isBestProduct || product.previous_price;

//       return hasHighRating || hasGoodSalesIndicator;
//     });

//     // Sort by ratings (highest first)
//     filteredProducts.sort((a, b) => {
//       const ratingA = typeof a.ratings === "number" ? a.ratings : 0;
//       const ratingB = typeof b.ratings === "number" ? b.ratings : 0;
//       return ratingB - ratingA;
//     });

//     // If no best sellers found, show products with any ratings
//     if (filteredProducts.length === 0) {
//       filteredProducts = products
//         .filter((product) => product.ratings && product.ratings > 0)
//         .sort((a, b) => b.ratings - a.ratings);
//     }
//   }

//   // FEATURED → Products marked as best or with special badges
//   if (activeFilter === "Featured") {
//     filteredProducts = products.filter(
//       (product) =>
//         product.isBestProduct === true ||
//         product.badge === "BEST" ||
//         product.badge === "FEATURED" ||
//         (product.previous_price && product.previous_price > product.price)
//     );
//   }

//   // Get localized category name
//   const getCategoryName = (category) => {
//     if (!category) return t("product");
    
//     if (typeof category === 'string') return category;
    
//     // Handle multilingual category object
//     if (typeof category === 'object') {
//       return getLocalizedText(category, "name");
//     }
    
//     return t("product");
//   };

//   // Get localized product name
//   const getProductName = (product) => {
//     if (!product) return "";
    
//     // Handle product object directly
//     if (product?.name && typeof product?.name === 'object') {
//       return getLocalizedText(product, "name");
//     }
    
//     // Handle product name from product object
//     if (product?.name) {
//       return typeof product?.name === 'string' ? product?.name : getLocalizedText(product, "name");
//     }
    
//     return t("unnamed_product");
//   };

//   return (
//     <div className="bg-white pb-10">
//       <div className="px-4 md:px-10">
//         {/* Header */}
//         <div className="flex flex-wrap justify-between items-center mb-10 gap-4">
//           <h2 className="text-3xl font-philosopher md:text-4xl text-gray-900">
//             {title}
//           </h2>

//           <div className="flex flex-wrap gap-6 text-sm pr-4">
//             {filters.map((filter, i) => (
//               <button
//                 key={i}
//                 onClick={() => setActiveFilter(filter)}
//                 className={`relative pb-1 ${
//                   activeFilter === filter
//                     ? "text-blue-600 font-semibold"
//                     : "text-gray-600 hover:text-gray-900"
//                 }`}
//               >
//                 {filter}
//                 {activeFilter === filter && (
//                   <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-600 rounded-full" />
//                 )}
//               </button>
//             ))}

//             <button
//               onClick={() => navigate(`/category/${categoryId}`)}
//               className="text-blue-600 hover:text-blue-700 font-semibold transition-colors duration-300"
//             >
//               {t("view_all")} →
//             </button>
//           </div>
//         </div>

//         {/* Layout */}
//         <div
//           className="grid grid-cols-1 lg:grid-cols-4 gap-8 items-start"
//           data-aos="fade-up"
//         >
//           {/* Banner - Updated for multilingual */}
//           <div
//             className="lg:col-span-1 relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 group"
//             style={{
//               backgroundImage: `url(${getLocalizedText(banner, "image") || banner.image})`,
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//               height: "485px",
//             }}
//           >
//             <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-all duration-500" />
//             <div className="relative z-10 h-full flex flex-col justify-between p-8 text-white">
//               <div>
//                 <h3 className="text-4xl font-poppins mb-3">
//                   {getLocalizedText(banner, "title") || banner.title}
//                 </h3>
//                 <p className="text-base opacity-90 mb-8 w-full">
//                   {getLocalizedText(banner, "subtitle") || banner.subtitle}
//                 </p>
//                 <button
//                   onClick={() => navigate(`/category/${categoryId}`)}
//                   className="group/btn relative overflow-hidden border-2 border-white px-8 py-3 text-sm font-bold rounded-lg transition-all duration-300 hover:scale-105"
//                 >
//                   <span className="relative z-10 group-hover/btn:text-black transition-colors duration-300">
//                     {t("shop_now")}
//                   </span>
//                   <span className="absolute inset-0 bg-white transform scale-x-0 group-hover/btn:scale-x-100 transition-transform duration-300 origin-left" />
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Product Carousel */}
//           <div className="lg:col-span-3 relative" data-aos="fade-left">
//             <button
//               onClick={() => scroll("left")}
//               className="absolute -left-4 top-1/2 -translate-y-1/2 z-20 bg-white shadow-xl rounded-full p-3 hover:bg-gray-900 hover:text-white transition"
//             >
//               <ChevronLeft className="w-6 h-6" />
//             </button>
//             <button
//               onClick={() => scroll("right")}
//               className="absolute -right-4 top-1/2 -translate-y-1/2 z-20 bg-white shadow-xl rounded-full p-3 hover:bg-gray-900 hover:text-white transition"
//             >
//               <ChevronRight className="w-6 h-6" />
//             </button>

//             <div
//               ref={scrollRef}
//               className="flex gap-4 overflow-x-auto scroll-smooth scrollbar-hide"
//             >
//               {filteredProducts.length > 0 ? (
//                 filteredProducts.map((product, index) => {
//                   const productId =
//                     product._id?.toString() || product.id?.toString();
//                   const isLiked = wishlist.includes(productId);
//                   const isHeartLoading = loadingHearts.has(productId);
//                   const isCartLoading = loadingCart.has(productId);
                  
//                   const productName = getProductName(product);
//                   const productCategory = getCategoryName(product.category);
//                   const productImage = product.image || 
//                     (product.images && product.images.length > 0 
//                       ? product.images[0] 
//                       : "https://via.placeholder.com/300x300?text=No+Image");

//                   return (
//                     <div
//                       key={productId}
//                       onClick={() => handleProductClick(productId)}
//                       className="min-w-[250px] max-w-[250px] bg-gray-100 rounded-2xl transition-all duration-500 flex-shrink-0 group transform hover:-translate-y-2 flex flex-col relative"
//                       data-aos="fade-up"
//                       data-aos-delay={index * 100}
//                     >
//                       {/* Wishlist Icon */}
//                       <button
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           toggleWishlist(productId);
//                         }}
//                         className="absolute top-4 right-4 z-10 p-2 rounded-full bg-white/90 shadow-md hover:bg-gray-100 transition-all duration-300"
//                         disabled={isHeartLoading}
//                       >
//                         {isHeartLoading ? (
//                           <Loader2 className="w-5 h-5 text-red-500 animate-spin" />
//                         ) : (
//                           <Heart
//                             className={`w-5 h-5 transition-all duration-300 ${
//                               isLiked
//                                 ? "fill-red-500 stroke-red-500"
//                                 : "stroke-gray-800 hover:scale-110"
//                             }`}
//                           />
//                         )}
//                       </button>

//                       {/* Product Image */}
//                       <div className="relative h-[290px] flex items-center justify-center overflow-hidden rounded-t-2xl bg-white">
//                         {product.badge && (
//                           <span className="absolute top-4 left-4 bg-gray-900 text-white text-xs font-bold px-3 py-1.5 rounded-md shadow-lg z-10">
//                             {product.badge}
//                           </span>
//                         )}
//                         <img
//                           src={productImage}
//                           alt={productName}
//                           className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
//                         />
//                       </div>

//                       {/* Info */}
//                       <div className="p-3 flex flex-col flex-grow">
//                         <h4 className="font-semibold text-sm mb-1 text-gray-900 group-hover:text-blue-600 transition line-clamp-2">
//                           {productName}
//                         </h4>

//                         {/* Category */}
//                         <p className="text-xs text-gray-500 mb-2">
//                           {productCategory}
//                         </p>

//                         {product.ratings !== undefined &&
//                           product.ratings !== null && (
//                             <div className="flex items-center gap-1 mb-2">
//                               {[...Array(5)].map((_, i) => (
//                                 <Star
//                                   key={i}
//                                   className={`w-4 h-4 ${
//                                     i < Math.round(Number(product.ratings))
//                                       ? "text-yellow-400 fill-yellow-400"
//                                       : "text-gray-300"
//                                   }`}
//                                 />
//                               ))}
//                               <span className="text-xs text-gray-500 ml-1">
//                                 {Number(product.ratings).toFixed(1)}
//                               </span>
//                             </div>
//                           )}

//                         <div className="flex gap-2 mt-auto mb-1 items-center">
//                           {product.originalPrice && (
//                             <div className="text-xs sm:text-sm text-red-400 line-through">
//                               {formatingPrice(
//                                 convertPrice(product.originalPrice),
//                                 currency
//                               )}
//                             </div>
//                           )}

//                           <div className="text-lg font-bold text-orange-500">
//                             {formatingPrice(
//                               convertPrice(product.salePrice || product.price),
//                               currency
//                             )}
//                           </div>
//                         </div>

//                         <button
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             handleAddToCart(productId);
//                           }}
//                           disabled={isCartLoading}
//                           className="w-full bg-white border-2 border-gray-900 text-gray-900 py-2 text-xs font-bold rounded-lg hover:bg-gray-900 hover:text-white transition-all duration-300 transform hover:scale-[1.02] disabled:opacity-70"
//                         >
//                           {isCartLoading ? (
//                             <div className="flex justify-center items-center gap-2">
//                               <Loader2 className="w-4 h-4 animate-spin" />
//                               {t("adding")}...
//                             </div>
//                           ) : (
//                             t("quick_add")
//                           )}
//                         </button>
//                       </div>
//                     </div>
//                   );
//                 })
//               ) : (
//                 <div className="w-full flex flex-col items-center justify-center py-16 px-8 text-center">
//                   <div className="bg-blue-50 rounded-full p-6 mb-4">
//                     <FilterX className="w-16 h-16 text-blue-500" />
//                   </div>
//                   <h3 className="text-2xl font-bold font-philosopher text-gray-800 mb-2">
//                     {t("no_products_found", { filter: activeFilter })}
//                   </h3>
//                   <p className="text-gray-600 mb-6 font-poppins max-w-md">
//                     {activeFilter === "New Products" &&
//                       t("no_new_products_message")}
//                     {activeFilter === "Best Sellers" &&
//                       t("no_best_sellers_message")}
//                     {activeFilter === "Featured" &&
//                       t("no_featured_products_message")}
//                   </p>
//                   <div className="flex gap-3">
//                     <button
//                       onClick={() => setActiveFilter(filters[0])}
//                       className="px-4 py-2 bg-[#172363] text-white text-sm rounded-lg font-poppins hover:bg-[#0a1556] transition-colors"
//                     >
//                       {t("show_all_products")}
//                     </button>
//                     <button
//                       onClick={() => navigate(`/category/${categoryId}`)}
//                       className="px-4 py-2 border border-gray-300 text-white 0 text-sm rounded-lg font-poppins bg-[#f38823] hover:bg-[#d96d14] transition-colors"
//                     >
//                       {t("browse_category")}
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         .scrollbar-hide::-webkit-scrollbar {
//           display: none;
//         }
//         .scrollbar-hide {
//           -ms-overflow-style: none;
//           scrollbar-width: none;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default ProductSection;



import React, { useEffect, useRef, useState } from "react";
import {
  ChevronLeft,
  ChevronRight,
  Heart,
  Loader2,
  Star,
  FilterX,
} from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { useCart } from "../../utils/CartContext";
import { useCurrency } from "../../context/CurrencyContext";
import { formatingPrice } from "../../utils/formatingPrice";
import { useTranslation } from "react-i18next";
import GuestSession from "../../utils/guestSession";

const ProductSection = ({
  title = "Shop By Category",
  filters = ["New Products", "Best Sellers", "Featured"],
  banner = {
    title: "Milancelos",
    subtitle: "Huge Saving on Home Appliances",
    discount: "",
    image: "/api/placeholder/250/250",
  },
  products = [],
  categoryId,
}) => {
  const scrollRef = useRef(null);
  const { currency, convertPrice } = useCurrency();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  const [activeFilter, setActiveFilter] = useState(filters[0]);
  const [wishlist, setWishlist] = useState([]);
  const [loadingHearts, setLoadingHearts] = useState(new Set());
  const [loadingCart, setLoadingCart] = useState(new Set());
  const navigate = useNavigate();
  const { fetchCartCount } = useCart();

  // Helper function to get localized text
  const getLocalizedText = (item, field) => {
    if (!item || !item[field]) return "";
    
    // If value is a string (backward compatibility)
    if (typeof item[field] === 'string') {
      return item[field];
    }
    
    // If value is an object with language keys
    if (typeof item[field] === 'object') {
      // Return the value in current language, fallback to English, then first available
      return item[field][currentLanguage] || 
             item[field].en || 
             item[field].hi || 
             item[field].es || 
             item[field].zh || 
             "";
    }
    
    return "";
  };

  // Get logged user
  const storedUser = localStorage.getItem("pm-user-data");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const userId = user?._id;

  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-out", once: true });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Load wishlist
  const fetchWishlist = async () => {
    if (!userId) {
      const localWishlist = JSON.parse(
        localStorage.getItem("guestWishlist") || "[]"
      );
      setWishlist(localWishlist);
      return;
    }
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/wishlist/wishlist-by-user/${userId}`
      );
      const ids = res?.data?.products?.map((p) => p._id?.toString()) || [];
      setWishlist(ids);
    } catch (error) {
      console.error("❌ Error fetching wishlist:", error);
    }
  };

  useEffect(() => {
    fetchWishlist();
  }, [userId]);

  // Wishlist toggle (works for both logged in and guest)
  const toggleWishlist = async (productId) => {
    const isLiked = wishlist.includes(productId.toString());
    setLoadingHearts((prev) => new Set(prev).add(productId));

    try {
      if (userId) {
        // Logged in user
        const endpoint = isLiked
          ? `${process.env.REACT_APP_API_URL}/wishlist/remove-from-wishlist`
          : `${process.env.REACT_APP_API_URL}/wishlist/add-to-wishlist`;

        await axios.post(endpoint, { userId, productId });
        await fetchWishlist();
        toast.success(isLiked ? "Removed from wishlist" : "Added to wishlist");
      } else {
        // Guest user - use localStorage
        let guestWishlist = JSON.parse(localStorage.getItem('guestWishlist') || '[]');
        if (isLiked) {
          guestWishlist = guestWishlist.filter(id => id !== productId);
        } else {
          guestWishlist.push(productId);
        }
        localStorage.setItem('guestWishlist', JSON.stringify(guestWishlist));
        setWishlist(guestWishlist);
        // Dispatch event for other components
        window.dispatchEvent(new Event('guest-wishlist-updated'));
        toast.success(isLiked ? "Removed from wishlist" : "Added to wishlist");
      }
    } catch (error) {
      toast.error(t("something_went_wrong") || "Something went wrong!");
    } finally {
      setLoadingHearts((prev) => {
        const newSet = new Set(prev);
        newSet.delete(productId);
        return newSet;
      });
    }
  };

  // Scroll function
  const scroll = (direction) => {
    if (!scrollRef.current) return;
    const scrollAmount = 320;
    scrollRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  // Add to cart (works for both logged in and guest)
  const handleAddToCart = async (productId) => {
    setLoadingCart((prev) => new Set(prev).add(productId));

    try {
      if (userId) {
        // Logged in user
        await axios.post(
          `${process.env.REACT_APP_API_URL}/cart/add-to-cart`,
          {
            userId,
            productId,
            quantity: 1,
          }
        );
      } else {
        // Guest user
        const guestId = GuestSession.getGuestId();
        await axios.post(
          `${process.env.REACT_APP_API_URL}/cart/add-to-cart`,
          {
            guestId,
            productId,
            quantity: 1,
          }
        );
      }
      toast.success("Added to cart!");
      await fetchCartCount();
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.error(error.response?.data?.message || "Failed to add to cart");
    } finally {
      setLoadingCart((prev) => {
        const newSet = new Set(prev);
        newSet.delete(productId);
        return newSet;
      });
    }
  };

  const handleProductClick = (id) => navigate(`/product-details/${id}`);

  // IMPROVED FILTER LOGIC WITH BETTER ERROR HANDLING
  let filteredProducts = [...products];

  // NEW PRODUCTS → Show products from last 30 days
  if (activeFilter === "New Products") {
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

    filteredProducts = products.filter((product) => {
      if (!product.createdAt) return false;
      const productDate = new Date(product.createdAt);
      return productDate >= thirtyDaysAgo;
    });

    // If no recent products, show all products sorted by newest first
    if (filteredProducts.length === 0) {
      filteredProducts = [...products]
        .sort((a, b) => {
          const dateA = a.createdAt ? new Date(a.createdAt) : new Date(0);
          const dateB = b.createdAt ? new Date(b.createdAt) : new Date(0);
          return dateB - dateA;
        })
        .slice(0, 8);
    }
  }

  // BEST SELLERS → Products with highest ratings (4+ stars) and good sales data
  if (activeFilter === "Best Sellers") {
    filteredProducts = products.filter((product) => {
      const rating = typeof product.ratings === "number" ? product.ratings : 0;
      const hasHighRating = rating >= 4.0;
      const hasGoodSalesIndicator =
        product.isBestProduct || product.previous_price;

      return hasHighRating || hasGoodSalesIndicator;
    });

    // Sort by ratings (highest first)
    filteredProducts.sort((a, b) => {
      const ratingA = typeof a.ratings === "number" ? a.ratings : 0;
      const ratingB = typeof b.ratings === "number" ? b.ratings : 0;
      return ratingB - ratingA;
    });

    // If no best sellers found, show products with any ratings
    if (filteredProducts.length === 0) {
      filteredProducts = products
        .filter((product) => product.ratings && product.ratings > 0)
        .sort((a, b) => b.ratings - a.ratings);
    }
  }

  // FEATURED → Products marked as best or with special badges
  if (activeFilter === "Featured") {
    filteredProducts = products.filter(
      (product) =>
        product.isBestProduct === true ||
        product.badge === "BEST" ||
        product.badge === "FEATURED" ||
        (product.previous_price && product.previous_price > product.price)
    );
  }

  // Get localized category name
  const getCategoryName = (category) => {
    if (!category) return t("product");
    
    if (typeof category === 'string') return category;
    
    // Handle multilingual category object
    if (typeof category === 'object') {
      return getLocalizedText(category, "name");
    }
    
    return t("product");
  };

  // Get localized product name
  const getProductName = (product) => {
    if (!product) return "";
    
    // Handle product object directly
    if (product?.name && typeof product?.name === 'object') {
      return getLocalizedText(product, "name");
    }
    
    // Handle product name from product object
    if (product?.name) {
      return typeof product?.name === 'string' ? product?.name : getLocalizedText(product, "name");
    }
    
    return t("unnamed_product");
  };

  return (
    <div className="bg-white pb-10">
      <div className="px-4 md:px-10">
        {/* Header */}
        <div className="flex flex-wrap justify-between items-center mb-10 gap-4">
          <h2 className="text-3xl font-philosopher md:text-4xl text-gray-900">
            {title}
          </h2>

          <div className="flex flex-wrap gap-6 text-sm pr-4">
            {filters.map((filter, i) => (
              <button
                key={i}
                onClick={() => setActiveFilter(filter)}
                className={`relative pb-1 ${
                  activeFilter === filter
                    ? "text-blue-600 font-semibold"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                {filter}
                {activeFilter === filter && (
                  <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-600 rounded-full" />
                )}
              </button>
            ))}

            <button
              onClick={() => navigate(`/category/${categoryId}`)}
              className="text-blue-600 hover:text-blue-700 font-semibold transition-colors duration-300"
            >
              {t("view_all")} →
            </button>
          </div>
        </div>

        {/* Layout */}
        <div
          className="grid grid-cols-1 lg:grid-cols-4 gap-8 items-start"
          data-aos="fade-up"
        >
          {/* Banner - Updated for multilingual */}
          <div
            className="lg:col-span-1 relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 group"
            style={{
              backgroundImage: `url(${getLocalizedText(banner, "image") || banner.image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "465px",
            }}
          >
            <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-all duration-500" />
            <div className="relative z-10 h-full flex flex-col justify-between p-8 text-white">
              <div>
                <h3 className="text-4xl font-poppins mb-3">
                  {getLocalizedText(banner, "title") || banner.title}
                </h3>
                <p className="text-base opacity-90 mb-8 w-full">
                  {getLocalizedText(banner, "subtitle") || banner.subtitle}
                </p>
                <button
                  onClick={() => navigate(`/category/${categoryId}`)}
                  className="group/btn relative overflow-hidden border-2 border-white px-8 py-3 text-sm font-bold rounded-lg transition-all duration-300 hover:scale-105"
                >
                  <span className="relative z-10 group-hover/btn:text-black transition-colors duration-300">
                    {t("shop_now")}
                  </span>
                  <span className="absolute inset-0 bg-white transform scale-x-0 group-hover/btn:scale-x-100 transition-transform duration-300 origin-left" />
                </button>
              </div>
            </div>
          </div>

          {/* Product Carousel */}
          <div className="lg:col-span-3 relative" data-aos="fade-left">
            <button
              onClick={() => scroll("left")}
              className="absolute -left-4 top-1/2 -translate-y-1/2 z-20 bg-white shadow-xl rounded-full p-3 hover:bg-gray-900 hover:text-white transition"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>
            <button
              onClick={() => scroll("right")}
              className="absolute -right-4 top-1/2 -translate-y-1/2 z-20 bg-white shadow-xl rounded-full p-3 hover:bg-gray-900 hover:text-white transition"
            >
              <ChevronRight className="w-6 h-6" />
            </button>

            <div
              ref={scrollRef}
              className="flex gap-4 overflow-x-auto scroll-smooth scrollbar-hide"
            >
              {filteredProducts.length > 0 ? (
                filteredProducts.map((product, index) => {
                  const productId =
                    product._id?.toString() || product.id?.toString();
                  const isLiked = wishlist.includes(productId);
                  const isHeartLoading = loadingHearts.has(productId);
                  const isCartLoading = loadingCart.has(productId);
                  
                  const productName = getProductName(product);
                  const productCategory = getCategoryName(product.category);
                  const productImage = product.image || 
                    (product.images && product.images.length > 0 
                      ? product.images[0] 
                      : "https://via.placeholder.com/300x300?text=No+Image");

                  return (
                    <div
                      key={productId}
                      onClick={() => handleProductClick(productId)}
                      className="min-w-[250px] max-w-[250px] bg-gray-100 rounded-2xl transition-all duration-500 flex-shrink-0 group transform hover:-translate-y-2 flex flex-col relative"
                      data-aos="fade-up"
                      data-aos-delay={index * 100}
                    >
                      {/* Wishlist Icon */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleWishlist(productId);
                        }}
                        className="absolute top-4 right-4 z-10 p-2 rounded-full bg-white/90 shadow-md hover:bg-gray-100 transition-all duration-300"
                        disabled={isHeartLoading}
                      >
                        {isHeartLoading ? (
                          <Loader2 className="w-5 h-5 text-red-500 animate-spin" />
                        ) : (
                          <Heart
                            className={`w-5 h-5 transition-all duration-300 ${
                              isLiked
                                ? "fill-red-500 stroke-red-500"
                                : "stroke-gray-800 hover:scale-110"
                            }`}
                          />
                        )}
                      </button>

                      {/* Product Image */}
                      <div className="relative h-[290px] flex items-center justify-center overflow-hidden rounded-t-2xl bg-white">
                        {product.badge && (
                          <span className="absolute top-4 left-4 bg-gray-900 text-white text-xs font-bold px-3 py-1.5 rounded-md shadow-lg z-10">
                            {product.badge}
                          </span>
                        )}
                        <img
                          src={productImage}
                          alt={productName}
                          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                          onError={(e) => {
                            e.target.src = "https://via.placeholder.com/300x300?text=No+Image";
                          }}
                        />
                      </div>

                      {/* Info */}
                      <div className="p-3 flex flex-col flex-grow">
                        <h4 className="font-semibold text-sm mb-1 text-gray-900 group-hover:text-blue-600 transition line-clamp-2">
                          {productName}
                        </h4>

                        {/* Category */}
                        <p className="text-xs text-gray-500 mb-2">
                          {productCategory}
                        </p>

                        {product.ratings !== undefined &&
                          product.ratings !== null && (
                            <div className="flex items-center gap-1 mb-2">
                              {[...Array(5)].map((_, i) => (
                                <Star
                                  key={i}
                                  className={`w-4 h-4 ${
                                    i < Math.round(Number(product.ratings))
                                      ? "text-yellow-400 fill-yellow-400"
                                      : "text-gray-300"
                                  }`}
                                />
                              ))}
                              <span className="text-xs text-gray-500 ml-1">
                                {Number(product.ratings).toFixed(1)}
                              </span>
                            </div>
                          )}

                        <div className="flex gap-2 mt-auto mb-1 items-center">
                          {product.originalPrice && (
                            <div className="text-xs sm:text-sm text-red-400 line-through">
                              {formatingPrice(
                                convertPrice(product.originalPrice),
                                currency
                              )}
                            </div>
                          )}

                          <div className="text-lg font-bold text-orange-500">
                            {formatingPrice(
                              convertPrice(product.salePrice || product.price),
                              currency
                            )}
                          </div>
                        </div>

                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAddToCart(productId);
                          }}
                          disabled={isCartLoading}
                          className="w-full bg-white border-2 border-gray-900 text-gray-900 py-2 text-xs font-bold rounded-lg hover:bg-gray-900 hover:text-white transition-all duration-300 transform hover:scale-[1.02] disabled:opacity-70"
                        >
                          {isCartLoading ? (
                            <div className="flex justify-center items-center gap-2">
                              <Loader2 className="w-4 h-4 animate-spin" />
                              {t("adding")}...
                            </div>
                          ) : (
                            t("quick_add")
                          )}
                        </button>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="w-full flex flex-col items-center justify-center py-16 px-8 text-center">
                  <div className="bg-blue-50 rounded-full p-6 mb-4">
                    <FilterX className="w-16 h-16 text-blue-500" />
                  </div>
                  <h3 className="text-2xl font-bold font-philosopher text-gray-800 mb-2">
                    {t("no_products_found", { filter: activeFilter })}
                  </h3>
                  <p className="text-gray-600 mb-6 font-poppins max-w-md">
                    {activeFilter === "New Products" &&
                      t("no_new_products_message")}
                    {activeFilter === "Best Sellers" &&
                      t("no_best_sellers_message")}
                    {activeFilter === "Featured" &&
                      t("no_featured_products_message")}
                  </p>
                  <div className="flex gap-3">
                    <button
                      onClick={() => setActiveFilter(filters[0])}
                      className="px-4 py-2 bg-[#172363] text-white text-sm rounded-lg font-poppins hover:bg-[#0a1556] transition-colors"
                    >
                      {t("show_all_products")}
                    </button>
                    <button
                      onClick={() => navigate(`/category/${categoryId}`)}
                      className="px-4 py-2 border border-gray-300 text-white text-sm rounded-lg font-poppins bg-[#f38823] hover:bg-[#d96d14] transition-colors"
                    >
                      {t("browse_category")}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default ProductSection;